import { gql } from '@apollo/client'
import { nullableConnectionNodes } from '@jusbrasil-web/shared-apollo-client/utilities'
import { ReactNode } from 'react'

import { useSegmentation } from '../../hooks/segmentation-hook'
import { AppbarBase } from '../appbar-base'
import { PublicationAppbar_DocumentFragment } from './__generated__/publication-appbar.graphql'

export interface PublicationAppbarProps {
  document: PublicationAppbar_DocumentFragment
  className?: string
  toolbar: ReactNode
}

const VISIBLE_TOPICS = 20

export function PublicationAppbar(props: PublicationAppbarProps) {
  const { document } = props

  const segmentationData = useSegmentation()

  const caption = segmentationData
    ? 'ARTIGO'
    : nullableConnectionNodes(document.topics)
        .slice(0, VISIBLE_TOPICS)
        .map((t) => t.title)
        .join(' · ')

  return <AppbarBase {...props} title={document.title} caption={caption} />
}

PublicationAppbar.fragments = {
  document: gql`
    fragment PublicationAppbar_document on Document {
      title
      topics(first: 1000, type: "MANUAL") {
        edges {
          node {
            title
          }
        }
      }
    }
  `,
}
